import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getGames } from '../../api';
import './Jeux.css';

const GAME_META = {
  'Le Miroir des Émotions': {
    icon: '🪞',
    theme: 'blue',
    to: '/app/jeux/miroir-emotions',
  },
  "L'Aventure de l'Amitié": {
    icon: '🌟',
    theme: 'purple',
    to: '/app/jeux/aventure-amitie',
  },
};

function getDifficultyColor(difficulty) {
  switch (difficulty) {
    case 'facile':   return '#4ade80';
    case 'moyen':    return '#fbbf24';
    case 'difficile':return '#f87171';
    default:         return '#888';
  }
}

function Jeux() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchGames() {
      try {
        const response = await getGames();
        setGames(response.data);
      } catch {
        setError('Impossible de charger les jeux');
      } finally {
        setLoading(false);
      }
    }
    fetchGames();
  }, []);

  return (
    <div className="jeux-page">

      {/* ── Hero ── */}
      <section className="jeux-hero">
        <div className="jeux-hero-text">
          <h1>Jeux</h1>
          <p>Choisis ton aventure et gagne de l'expérience !</p>
        </div>
        <span className="jeux-hero-icon" aria-hidden="true">🎮</span>
      </section>

      {/* ── Grille ── */}
      {loading && <p className="jeux-loading">Chargement...</p>}
      {error  && <p className="jeux-error">{error}</p>}

      {!loading && !error && (
        <section>
          <h2 className="jeux-section-title">Tous les jeux</h2>

          {games.length === 0 ? (
            <p className="jeux-empty">Aucun jeu disponible pour le moment.</p>
          ) : (
            <div className="jeux-grid">
              {games.map((game) => {
                const meta = GAME_META[game.name] ?? { icon: '🎮', theme: 'default' };

                const button = meta.to ? (
                  <Link to={meta.to} className={`jeu-button jeu-button-${meta.theme}`}>
                    Jouer
                  </Link>
                ) : (
                  <a
                    href={game.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`jeu-button jeu-button-${meta.theme}`}
                  >
                    Jouer
                  </a>
                );

                return (
                  <div key={game.id} className={`jeu-card jeu-card-${meta.theme}`}>
                    <div className="jeu-card-icon">{meta.icon}</div>

                    <div className="jeu-card-body">
                      <div className="jeu-header">
                        <h3>{game.name}</h3>
                        <span
                          className="jeu-difficulty"
                          style={{ color: getDifficultyColor(game.difficulty) }}
                        >
                          {game.difficulty}
                        </span>
                      </div>
                      <p className="jeu-description">{game.description}</p>
                      <div className="jeu-xp">
                        <span>+{game.participation_xp} XP participation</span>
                        <span>+{game.victory_xp} XP victoire</span>
                      </div>
                      {button}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </section>
      )}
    </div>
  );
}

export default Jeux;
